module.exports = __webpack_public_path__ + "img/51626499_L.4d1a8102.png";